import Time from './component'
export { Time }
export default Time